import config from '@/config'
import api from '@/api'
import utils from '@/utils'
import Vue from "vue";
let o = {}
o.expiredToLogin = function () {
  setTimeout(() => {
    Vue.toasted.show('页面已过期,请重新登录', {
      duration: 3000
    })
    var isIP = utils.isIP(window.location.hostname);
    var expired = 'expired'
    if (!isIP) { // 域名/localhost的情况
      if (window.location.hostname == 'localhost') {
        window.location.href = 'http://localhost:8080/#/byl/login?expired=' + expired
      } else {
        window.location.href = 'http://' + $global_api.DEFAULT_DOMAIN + ':' + $global_api.webport + '/#/byl/login?expired=' + expired
      }
    } else {
      if ($global_api.DEPLOY) {
        window.location.href = 'http://' + window.location.hostname + '/#/byl/login?expired=' + expired
      } else {
        window.location.href = 'http://' + window.location.hostname + ':' + $global_api.webport + '/#/byl/login?expired=' + expired
      }
    }
  }, 500)
}
export default o



// WEBPACK FOOTER //
// ./src/utils/expired.js